import React from "react";

/** Count checked columns; pass extraCols for checkbox/action columns outside headers. */
export function visibleTableColumnCount(headers, extraCols = 0) {
  const checked = (headers || []).filter((head) => head.checked).length;
  return Math.max(checked + extraCols, 1);
}

const DEFAULT_CELL_CLASS =
  "border-b border-slate-200/80 px-3 py-10 text-center text-sm font-medium text-slate-500";

export default function TableEmptyRow({
  colSpan,
  message = "No records found",
  className = DEFAULT_CELL_CLASS,
}) {
  const span = Math.max(Number(colSpan) || 1, 1);
  return (
    <tr className="cms-table-empty-row">
      <td colSpan={span} className={className}>
        {message}
      </td>
    </tr>
  );
}
